export default __webpack_public_path__ + "afa774b9763b0fb8f5ad5da1f52686b2.png";